import React from 'react';
import { LoginCenteredBoxLayout } from 'layout';
// import { Login } from '@isyc-react/auth/modules/pods/login'
import { namespaces } from 'i18n/i18n.constants';
import { useTranslation } from 'react-i18next';
export const LoginScene = () => {
    const { t } = useTranslation(namespaces.common);
    return React.createElement(LoginCenteredBoxLayout, null);
};
